import { NgModule, ModuleWithProviders, Provider } from '@angular/core';
import { FormlyModule } from '@ngx-formly/core';

import { FormlyFieldComboboxComponent } from './formly-template';
import { FormlyValidation } from './formly-validation';
import { FormlyWrapperPanelComponent } from './formly-wrapper';
import { SharedModule } from './shared/shared.module';

/**
 * Formly global configuration
 */
const formlyModuleProviders = FormlyModule.forRoot({
  types: [{ name: 'combobox', component: FormlyFieldComboboxComponent }],
  wrappers: [{ name: 'panel', component: FormlyWrapperPanelComponent }],
  validationMessages: [],
}).providers as Provider[];

@NgModule({
  imports: [SharedModule],
  declarations: [FormlyFieldComboboxComponent, FormlyWrapperPanelComponent],
  providers: [FormlyValidation],
})
export class FormlyConfigModule {
  constructor(formlyValidation: FormlyValidation) {
    formlyValidation.init();
  }

  static forRoot(): ModuleWithProviders<FormlyConfigModule> {
    return {
      ngModule: FormlyConfigModule,
      providers: [formlyModuleProviders],
    };
  }
}
